/* =========================================================
   STOREFRONT PRODUCT DISPLAY SETTINGS
   SKU / brand visibility only. Color swatches remain unchanged.
========================================================= */
(function () {
  window.POC = window.POC || {};
  POC.state = POC.state || {};

  var defaults = {
    productGrid: {
      showSku: false,
      showBrand: false,
      showCategoryCounts: true,
      showLabelFilters: true,

      // Release 1 storefront defaults. Controls remain in the DOM and all
      // underlying filter logic remains active for future Admin toggles.
      showPackagesFilter: true,
      showAllLabelsFilter: false,
      showFeaturedFilter: false,
      showTopPickFilter: false,
      showRecommendedFilter: false,
      showOnSaleFilter: false,
      showCuratedOnlyControl: false
    },
    productDetail: { showSku: false, showBrand: false },
    categoryDisplayNames: {}
  };

  POC.state.storefrontDisplaySettings =
    POC.state.storefrontDisplaySettings || defaults;

  function apply(settings) {
    settings = settings || {};

    // Merge the current endpoint response with safe storefront defaults.
    // This keeps Release 1 compatible with the existing Azure schema while
    // allowing Release 2 to add the individual Admin-controlled flags later.
    var resolvedSettings = Object.assign({}, defaults, settings);
    resolvedSettings.productGrid = Object.assign(
      {},
      defaults.productGrid,
      settings.productGrid || {}
    );
    resolvedSettings.productDetail = Object.assign(
      {},
      defaults.productDetail,
      settings.productDetail || {}
    );
    resolvedSettings.categoryDisplayNames = Object.assign(
      {},
      defaults.categoryDisplayNames,
      settings.categoryDisplayNames || {}
    );

    POC.state.storefrontDisplaySettings = resolvedSettings;

    if (
      POC.render &&
      typeof POC.render.renderCategories === "function" &&
      POC.state &&
      Array.isArray(POC.state.categories) &&
      POC.state.categories.length
    ) {
      POC.render.renderCategories(POC.state.categories);
    }

    var grid = resolvedSettings.productGrid || {};
    document.documentElement.classList.toggle(
      "ua-show-grid-sku",
      grid.showSku === true
    );
    document.documentElement.classList.toggle(
      "ua-show-grid-brand",
      grid.showBrand === true
    );

    document.documentElement.classList.toggle(
      "ua-hide-category-counts",
      grid.showCategoryCounts === false
    );

    var hasIndividualFilterVisibility =
      typeof grid.showAllLabelsFilter === "boolean" ||
      typeof grid.showFeaturedFilter === "boolean" ||
      typeof grid.showTopPickFilter === "boolean" ||
      typeof grid.showRecommendedFilter === "boolean" ||
      typeof grid.showOnSaleFilter === "boolean";

    document.documentElement.classList.toggle(
      "ua-hide-optional-label-filters",
      !hasIndividualFilterVisibility && grid.showLabelFilters === false
    );

    document.documentElement.classList.toggle(
      "ua-hide-packages-filter",
      grid.showPackagesFilter !== true
    );
    document.documentElement.classList.toggle(
      "ua-hide-all-labels-filter",
      grid.showAllLabelsFilter !== true
    );
    document.documentElement.classList.toggle(
      "ua-hide-featured-filter",
      grid.showFeaturedFilter !== true
    );
    document.documentElement.classList.toggle(
      "ua-hide-top-pick-filter",
      grid.showTopPickFilter !== true
    );
    document.documentElement.classList.toggle(
      "ua-hide-recommended-filter",
      grid.showRecommendedFilter !== true
    );
    document.documentElement.classList.toggle(
      "ua-hide-on-sale-filter",
      grid.showOnSaleFilter !== true
    );
    document.documentElement.classList.toggle(
      "ua-hide-curated-only-control",
      grid.showCuratedOnlyControl !== true
    );
  }

  function installStyle() {
    if (document.getElementById("ua-storefront-display-style")) return;

    var style = document.createElement("style");
    style.id = "ua-storefront-display-style";
    style.textContent =
      ".ua-product-meta-sku,.ua-product-meta-brand{display:none}" +
      ".ua-show-grid-sku .ua-product-meta-sku{display:inline}" +
      ".ua-show-grid-brand .ua-product-meta-brand{display:inline}" +
      ".ua-product-meta-separator{display:none}" +
      ".ua-show-grid-sku.ua-show-grid-brand .ua-product-meta-separator{display:inline}" +
      ".ua-hide-category-counts .poc-demo-tree__count{display:none!important}" +
      ".ua-hide-optional-label-filters .poc-demo-optional-label-filters{display:none!important}" +
      ".ua-hide-packages-filter .ua-filter-control--packages{display:none!important}" +
      ".ua-hide-all-labels-filter .ua-filter-control--all-labels{display:none!important}" +
      ".ua-hide-featured-filter .ua-filter-control--featured{display:none!important}" +
      ".ua-hide-top-pick-filter .ua-filter-control--top-pick{display:none!important}" +
      ".ua-hide-recommended-filter .ua-filter-control--recommended{display:none!important}" +
      ".ua-hide-on-sale-filter .ua-filter-control--on-sale{display:none!important}" +
      ".ua-hide-curated-only-control .ua-filter-control--curated-only{display:none!important}";
    document.head.appendChild(style);
  }

  installStyle();
  apply(POC.state.storefrontDisplaySettings);

  fetch("/apps/inksoft/storefront/display-settings", {
    method: "GET",
    cache: "no-store",
    credentials: "same-origin"
  })
    .then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status);
      return response.json();
    })
    .then(function (payload) {
      apply(payload && payload.data ? payload.data : defaults);
    })
    .catch(function () {
      apply(defaults);
    });
})();

window.POC = window.POC || {};

POC.render = {
  _catalogBadgeSourceVersion: "catalog-badge-v9-full-dataset-search-v11-combo-messaging-brand-filtered-results-v3",
  _renderCycleId: 0,
  _categoryTreeInitialized: false,

  isMobileCatalogue() {
    return !!(
      window.matchMedia &&
      window.matchMedia("(max-width: 749px)").matches
    );
  },

  setSidebarLoadingState(isLoading) {
    var header = document.querySelector(".poc-demo-sidebar__title");
    if (!header) return;

    var loader = header.querySelector(".poc-demo-sidebar__loader");

    if (isLoading) {
      if (!loader) {
        loader = document.createElement("span");
        loader.className = "poc-demo-sidebar__loader";
        loader.innerHTML = '<span class="poc-demo-spinner"></span>';
        header.appendChild(loader);
      }
    } else {
      if (loader) loader.remove();
    }
  },

  nextRenderCycleId() {
    this._renderCycleId = Number(this._renderCycleId || 0) + 1;
    return this._renderCycleId;
  },

  ensureCategoryTreeState() {
    POC.state = POC.state || {};
    if (!POC.state.categoryTree) {
      POC.state.categoryTree = { expanded: {} };
    }
    if (!POC.state.categoryTree.expanded) {
      POC.state.categoryTree.expanded = {};
    }
  },

  getCategoryDisplayName(sourceName) {
    var original = String(sourceName || "").trim();
    if (!original) return original;

    var settings =
      POC.state &&
      POC.state.storefrontDisplaySettings
        ? POC.state.storefrontDisplaySettings
        : {};

    var aliases =
      settings && settings.categoryDisplayNames
        ? settings.categoryDisplayNames
        : {};

    if (aliases[original]) {
      return String(aliases[original]).trim() || original;
    }

    var wanted = original.toLowerCase();
    var keys = Object.keys(aliases);

    for (var index = 0; index < keys.length; index += 1) {
      if (String(keys[index]).toLowerCase() === wanted) {
        return String(aliases[keys[index]] || "").trim() || original;
      }
    }

    return original;
  },

  updateCategoryCounts(categories) {
    if (!Array.isArray(categories)) return;

    function resolveCount(category) {
      if (!category) return 0;
      return Number(
        category.itemCount ||
        category.ItemCount ||
        category.count ||
        category.Count ||
        0
      );
    }

    function walk(list) {
      list.forEach(function (category) {
        var id = category && (category.id != null ? category.id : category.CategoryId);
        if (id == null) return;

        var count = resolveCount(category);
        var el = document.querySelector('[data-category-count="' + String(id) + '"]');

        if (el) {
          el.textContent = count > 0 ? "(" + count + ")" : "";
        }

        var children =
          category.children ||
          category.Children ||
          category.subCategories ||
          category.SubCategories ||
          [];

        if (Array.isArray(children) && children.length) {
          walk(children);
        }
      });
    }

    walk(categories);
  },  

  // =========================================
  // 🔥 FIXED: renderCategories (NO DUPLICATES / NO TREE FALLBACK)
  // =========================================
  renderCategories(categories) {
    var treeEl = document.getElementById("poc-demo-category-tree");
    if (!treeEl) return;

    this.ensureCategoryTreeState();

    if (!this._categoryTreeInitialized) {
      POC.state.categoryTree = {
        expanded: {}
      };
      this._categoryTreeInitialized = true;
    }

    var allPayload = POC.state.productsByCategory && POC.state.productsByCategory["ALL"];
    var selectedId = String(POC.state.selectedCategoryId || "ALL");
    var selectedPayload = POC.state.productsByCategory && POC.state.productsByCategory[selectedId];
    var isLoading = POC.state.sidebar && POC.state.sidebar.loadingAll;

    function resolvePayloadCount(payload) {
      if (!payload) return 0;
      if (typeof payload.total === "number") return payload.total;
      if (typeof payload.count === "number") return payload.count;
      if (typeof payload.itemCount === "number") return payload.itemCount;
      if (typeof payload.totalCount === "number") return payload.totalCount;
      if (Array.isArray(payload.products)) return payload.products.length;
      if (Array.isArray(payload.items)) return payload.items.length;
      if (Array.isArray(payload.data)) return payload.data.length;
      if (Array.isArray(payload.results)) return payload.results.length;
      return 0;
    }

    var allCount = 0;
    var resolvedAllCount = resolvePayloadCount(allPayload);

    // ✅ SINGLE SOURCE OF TRUTH
    if (resolvedAllCount > 0) {
      allCount = resolvedAllCount;
      POC.state.sidebarAllCount = resolvedAllCount;
    } else if (selectedId === "ALL") {
      var selectedCount = resolvePayloadCount(selectedPayload);
      if (selectedCount > 0) {
        allCount = selectedCount;
        POC.state.sidebarAllCount = selectedCount;
      } else {
        allCount = POC.state.sidebarAllCount || 0;
      }
    } else {
      allCount = POC.state.sidebarAllCount || 0;
    }

    var countHtml = isLoading
      ? '(Loading...)'
      : '(' + POC.ui.escapeHtml(allCount) + ')';

    var hasActiveTagOrPackageFilter = !!this.getUrlFilterValueForEmptyState(
      (POC.state && POC.state.filters) || {}
    );

    var allItemHtml =
      '<button type="button" class="poc-demo-tree__leaf' +
      (selectedId === "ALL" && !hasActiveTagOrPackageFilter ? " is-active" : "") +
      '" data-category-id="ALL" data-category-name="All Products" style="padding:10px 12px 10px 10px;display:flex;align-items:center;gap:0;">' +
        this.buildToggleSpacer() +
        '<span class="poc-demo-tree__label">All Products <span class="poc-demo-tree__count">' + countHtml + '</span></span>' +
      '</button>';

    var categoryHtml = (Array.isArray(categories) ? categories : [])
      .filter(function (category) {
        // DO NOT block rendering — show all categories immediately
        return true;
      })

      .map(function (category) {
        return POC.render.buildCategoryNodeHtml(category, 0);
      })
      .join("");

    treeEl.innerHTML = allItemHtml + categoryHtml;

    this.setSidebarLoadingState(isLoading);

    // CLICK HANDLERS
    Array.prototype.forEach.call(
      treeEl.querySelectorAll("[data-category-id]"),
      function (button) {
        button.addEventListener("click", function (event) {
          var toggleButton = event.target?.closest?.("[data-category-toggle]");
          if (toggleButton) return;

          var categoryId = button.getAttribute("data-category-id") || "ALL";
          var categoryName = button.getAttribute("data-category-name") || "Products";

          if (categoryId === "ALL") {
            POC.core.setSidebarAllLoading(true);
          }

          /*
            URL-based package/tag landing pages (for example
            ?tag=Package_Spiritwear) should return to normal catalogue
            navigation when the customer clicks a sidebar category.

            Do not reset the manually selected Packages / Package Deals
            curated filter here. That filter is allowed to combine with a
            category, for example: T-Shirts — Package Deals.
          */
          var activeFilters =
            (POC.state && POC.state.filters) || {};
          var hasUrlPackageOrTagFilter = !!(
            activeFilters.tag ||
            activeFilters.tagSource ||
            activeFilters.urlFilterRequested
          );

          if (
            hasUrlPackageOrTagFilter &&
            POC.core &&
            typeof POC.core.resetFiltersForCategoryNavigation === "function"
          ) {
            POC.core.resetFiltersForCategoryNavigation();
          }

          POC.render.syncCategoryParamToUrl(categoryId, categoryName);
          POC.core.loadCategory(categoryId, categoryName);
        });
      }
    );

    Array.prototype.forEach.call(
      treeEl.querySelectorAll("[data-category-toggle]"),
      function (toggle) {
        toggle.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          var categoryId = toggle.getAttribute("data-category-toggle") || "";
          POC.render.toggleCategoryExpanded(categoryId);
        });
      }
    );
  },

    normalizeTag(tag) {
    var value = String(tag || "").toLowerCase().trim();

    // Catalog badges accept both the newer catalog_badge_* namespace and
    // the existing curated_* namespace, but only from explicit current
    // InkSoft Store Search Tag fields. Derived/legacy metadata remains ignored.
    if (value === "catalog-badge-featured") value = "catalog_badge_featured";
    if (value === "catalog_badge_top") value = "catalog_badge_top_pick";
    if (value === "catalog-badge-top") value = "catalog_badge_top_pick";
    if (value === "catalog_badge_toppick") value = "catalog_badge_top_pick";
    if (value === "catalog-badge-top-pick") value = "catalog_badge_top_pick";
    if (value === "catalog_badge_recommeded") value = "catalog_badge_recommended";
    if (value === "catalog-badge-recommended") value = "catalog_badge_recommended";
    if (value === "catalog_badge_onsale") value = "catalog_badge_on_sale";
    if (value === "catalog_badge_on-sale") value = "catalog_badge_on_sale";
    if (value === "catalog-badge-on-sale") value = "catalog_badge_on_sale";
    if (value === "catalog_badge_package") value = "catalog_badge_package";
    if (value === "catalog-badge-package") value = "catalog_badge_package";

    if (value === "curated_recommeded") value = "curated_recommended";
    if (value === "curated-recommended") value = "curated_recommended";
    if (value === "curated_onsale") value = "curated_on_sale";
    if (value === "curated_on-sale") value = "curated_on_sale";
    if (value === "curated_on-sales") value = "curated_on_sale";
    if (value === "curated_top-pick") value = "curated_top";
    if (value === "curated_toppick") value = "curated_top";

    return value;
  },

  getProductTags(product) {
    var rawTags = [];

    function appendTagValues(value) {
      if (value == null) return;

      if (Array.isArray(value)) {
        value.forEach(appendTagValues);
        return;
      }

      if (typeof value === "string") {
        value
          .split(/[;,|]/g)
          .map(function (item) { return item.trim(); })
          .filter(Boolean)
          .forEach(function (item) { rawTags.push(item); });
        return;
      }

      if (typeof value === "object") {
        Object.keys(value).forEach(function (key) {
          appendTagValues(value[key]);
        });
      }
    }

    /*
      Current InkSoft tag fields are the only source of truth.

      Deliberately ignored:
      - curatedTags / CuratedTags
      - curatedRank
      - isCurated / IsCurated

      Those legacy, derived fields can remain stale after a Store Search Tag is
      removed in InkSoft and were the reason old FEATURED/TOP PICK labels stayed
      visible after cache clearing.
    */
    if (product) {
      appendTagValues(product.tags);
      appendTagValues(product.Tags);
      appendTagValues(product.searchTags);
      appendTagValues(product.SearchTags);
      appendTagValues(product.storeSearchTags);
      appendTagValues(product.StoreSearchTags);
      appendTagValues(product.store_search_tags);
      appendTagValues(product["Store Search Tags"]);

      if (product.raw) {
        appendTagValues(product.raw.tags);
        appendTagValues(product.raw.Tags);
        appendTagValues(product.raw.searchTags);
        appendTagValues(product.raw.SearchTags);
        appendTagValues(product.raw.storeSearchTags);
        appendTagValues(product.raw.StoreSearchTags);
        appendTagValues(product.raw.store_search_tags);
        appendTagValues(product.raw["Store Search Tags"]);
      }
    }

    var seen = {};
    var normalized = [];

    rawTags.forEach(function (tag) {
      var value = POC.render.normalizeTag(tag);
      if (!value || seen[value]) return;
      seen[value] = true;
      normalized.push(value);
    });

    return normalized;
  },

  hasCatalogBadgesActive(product) {
    var found = false;
    var seen = [];

    function inspect(value) {
      if (found || value == null) return;

      if (typeof value === "string") {
        value
          .split(/[;,|]/g)
          .map(function (item) { return item.trim(); })
          .filter(Boolean)
          .forEach(function (item) {
            if (POC.render.normalizeTag(item) === "catalog_badges_active") {
              found = true;
            }
          });
        return;
      }

      if (typeof value !== "object") return;
      if (seen.indexOf(value) !== -1) return;
      seen.push(value);

      if (Array.isArray(value)) {
        value.forEach(inspect);
        return;
      }

      Object.keys(value).forEach(function (key) {
        inspect(value[key]);
      });
    }

    /*
      Azure may place the current InkSoft Store Search Tags in nested
      product.raw / product.raw._inksoftDetail / product.tags fields.
      Search the complete product record for the exact activation tag.
      Stale badges still remain blocked unless this exact tag is present.
    */
    inspect(product);

    return found;
  },

  getCuratedTags(product) {
    /*
      No activation tag means no catalog badges, even when stale curated_*
      metadata remains in Azure or older synchronized product snapshots.
    */
    if (!this.hasCatalogBadgesActive(product)) return [];

    var rawTags = [];

    function appendTagValues(value) {
      if (value == null) return;

      if (Array.isArray(value)) {
        value.forEach(appendTagValues);
        return;
      }

      if (typeof value === "string") {
        value
          .split(/[;,|]/g)
          .map(function (item) { return item.trim(); })
          .filter(Boolean)
          .forEach(function (item) { rawTags.push(item); });
        return;
      }

      if (typeof value === "object") {
        Object.keys(value).forEach(function (key) {
          appendTagValues(value[key]);
        });
      }
    }

    /*
      Catalog badges are intentionally stricter than general search.
      Only the explicit InkSoft Store Search Tags fields may create a badge.
      Generic `tags`, `searchTags`, legacy `curatedTags`, derived flags, and
      nested `product.data` snapshots are ignored because they can retain stale
      development labels after a Store Search Tag is removed in InkSoft.

      Accepted namespaces:
      - catalog_badge_*
      - curated_*
    */
    if (product) {
      appendTagValues(product.storeSearchTags);
      appendTagValues(product.StoreSearchTags);
      appendTagValues(product.store_search_tags);
      appendTagValues(product["Store Search Tags"]);

      if (product.raw) {
        appendTagValues(product.raw.storeSearchTags);
        appendTagValues(product.raw.StoreSearchTags);
        appendTagValues(product.raw.store_search_tags);
        appendTagValues(product.raw["Store Search Tags"]);
      }

      /*
        Compatibility fallback for PACKAGE only.

        Some Azure product records expose the current curated_package tag in
        generic search/tag fields instead of StoreSearchTags. We intentionally
        read only the package tag from these fallback locations so old sample
        Featured/Top Pick/Recommended/On Sale metadata cannot return.
      */
      var packageFallbackValues = [];

      function collectPackageFallback(value) {
        if (value == null) return;

        if (Array.isArray(value)) {
          value.forEach(collectPackageFallback);
          return;
        }

        if (typeof value === "string") {
          value
            .split(/[;,|]/g)
            .map(function (item) { return item.trim(); })
            .filter(Boolean)
            .forEach(function (item) { packageFallbackValues.push(item); });
          return;
        }

        if (typeof value === "object") {
          Object.keys(value).forEach(function (key) {
            collectPackageFallback(value[key]);
          });
        }
      }

      collectPackageFallback(product.searchTags);
      collectPackageFallback(product.SearchTags);
      collectPackageFallback(product.tags);
      collectPackageFallback(product.Tags);

      if (product.raw) {
        collectPackageFallback(product.raw.searchTags);
        collectPackageFallback(product.raw.SearchTags);
        collectPackageFallback(product.raw.tags);
        collectPackageFallback(product.raw.Tags);
      }

      packageFallbackValues.forEach(function (tag) {
        var normalized = POC.render.normalizeTag(tag);
        if (normalized === "curated_package" || normalized === "catalog_badge_package") {
          rawTags.push(normalized);
        }
      });

    }

    var seen = {};

    return rawTags.map(function (tag) {
      return POC.render.normalizeTag(tag);
    }).filter(function (tag) {
      var supported = tag && tag !== "catalog_badges_active" && (
        tag.indexOf("catalog_badge_") === 0 ||
        tag.indexOf("curated_") === 0
      );
      if (!supported || seen[tag]) return false;
      seen[tag] = true;
      return true;
    });
  },

  getCuratedLabels(product) {
    var tags = this.getCuratedTags(product);
    var labels = [];

    tags.forEach(function (tag) {
      if (tag === "catalog_badge_featured" || tag === "curated_featured") {
        labels.push({ text: "FEATURED", className: "featured" });
      } else if (tag === "catalog_badge_top_pick" || tag === "curated_top") {
        labels.push({ text: "TOP PICK", className: "top-pick" });
      } else if (tag === "catalog_badge_recommended" || tag === "curated_recommended") {
        labels.push({ text: "RECOMMENDED", className: "recommended" });
      } else if (tag === "catalog_badge_on_sale" || tag === "curated_on_sale") {
        labels.push({ text: "ON SALE", className: "on-sale" });
      } else if (tag === "catalog_badge_package" || tag === "curated_package") {
        labels.push({ text: "PACKAGE", className: "package" });
      } else {
        labels.push({
          text: tag.replace(/^catalog_badge_/, "").replace(/^curated_/, "").replace(/[_-]/g, " ").toUpperCase(),
          className: "curated"
        });
      }
    });

    return labels;
  },

  getCuratedRank(product) {
    var tags = this.getCuratedTags(product);
    if (tags.indexOf("catalog_badge_featured") >= 0 || tags.indexOf("curated_featured") >= 0) return 1;
    if (tags.indexOf("catalog_badge_top_pick") >= 0 || tags.indexOf("curated_top") >= 0) return 2;
    if (tags.indexOf("catalog_badge_recommended") >= 0 || tags.indexOf("curated_recommended") >= 0) return 3;
    if (tags.indexOf("catalog_badge_on_sale") >= 0 || tags.indexOf("curated_on_sale") >= 0) return 4;
    if (tags.indexOf("catalog_badge_package") >= 0 || tags.indexOf("curated_package") >= 0) return 5;
    return 9999;
  },

  isCurated(product) {
    if (!product) return false;
    return this.getCuratedTags(product).length > 0;
  },

  normalizeText(value) {
    return String(value || "").toLowerCase().trim();
  },

  getCategorySlug(value) {
    return String(value || "")
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  },

  getCategoryParamFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return this.getCategorySlug(params.get("category") || "");
    } catch (error) {
      return "";
    }
  },

  findCategoryBySlug(categories, slug) {
    if (!slug || !Array.isArray(categories)) return null;

    for (var i = 0; i < categories.length; i++) {
      var category = categories[i];
      if (!category) continue;

      var name =
        category.name ||
        category.Name ||
        category.CategoryName ||
        category.categoryName ||
        "";

      if (this.getCategorySlug(name) === slug) {
        return category;
      }

      var children =
        category.children ||
        category.Children ||
        category.SubCategories ||
        category.subCategories ||
        [];

      if (children.length) {
        var match = this.findCategoryBySlug(children, slug);
        if (match) return match;
      }
    }

    return null;
  },

  syncCategoryParamToUrl(categoryId, categoryName) {
    try {
      var url = new URL(window.location.href);

      if (String(categoryId || "").toUpperCase() === "ALL") {
        url.searchParams.delete("category");
      } else {
        var slug = this.getCategorySlug(categoryName);
        if (slug) {
          url.searchParams.set("category", slug);
        }
      }

      window.history.replaceState({}, "", url.toString());
    } catch (error) {}
  },

  buildSearchText(product) {
    var detail = this.getProductDetailCandidate(product) || product || {};
    var raw = detail.raw || product && product.raw || {};

    return [
      detail.name, detail.Name, detail.title, detail.Title,
      detail.sku, detail.SKU, detail.productSku, detail.ProductSKU,
      product && product.sku, product && product.SKU,
      raw.sku, raw.SKU, raw.productSku, raw.ProductSKU,
      this.getProductManufacturerSkuValue(detail),
      detail.manufacturerSku, detail.manufacturerSKU,
      detail.brand, detail.Brand, detail.manufacturerName, detail.ManufacturerName,
      detail.supplier, detail.Supplier,
      detail.description, detail.Description,
      detail.id, detail.ID, detail.productId, detail.ProductId,
      this.getProductTags(detail).join(" ")
    ].filter(Boolean).join(" ").toLowerCase();
  },

  matchesSearch(product, searchTerm) {
    if (!searchTerm) return true;
    return this.buildSearchText(product).indexOf(searchTerm) >= 0;
  },

  matchesCuratedFilters(product) {
    var filters = POC.state.filters || {};
    var curatedOnly = !!filters.curatedOnly;

    var selectedLabel = String(
      filters.curatedFilter || "ALL"
    )
      .trim()
      .toUpperCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");

    var labels = this.getCuratedLabels(product);
    var isCurated = this.isCurated(product);

    if (curatedOnly && !isCurated) return false;
    if (!selectedLabel || selectedLabel === "ALL") return true;

    var normalizedLabelTexts = labels.map(function (item) {
      return String(item && item.text || "")
        .trim()
        .toUpperCase()
        .replace(/[_-]+/g, " ")
        .replace(/\s+/g, " ");
    });

    /*
      PACKAGE filter compatibility.

      Customer-facing package badges and filters may use PACKAGE,
      PACKAGES, PACKAGE DEAL, or PACKAGE DEALS. Treat those values as
      equivalent and also verify the underlying InkSoft package tags.
    */
    if (
      selectedLabel === "PACKAGE" ||
      selectedLabel === "PACKAGES" ||
      selectedLabel === "PACKAGE DEAL" ||
      selectedLabel === "PACKAGE DEALS"
    ) {
      var hasPackageLabel = normalizedLabelTexts.some(function (label) {
        return (
          label === "PACKAGE" ||
          label === "PACKAGES" ||
          label === "PACKAGE DEAL" ||
          label === "PACKAGE DEALS" ||
          label.indexOf("PACKAGE ") === 0
        );
      });

      if (hasPackageLabel) return true;

      var allTags = this
        .getCuratedTags(product)
        .concat(this.getProductTags(product));

      return allTags.some(function (tag) {
        var normalizedTag = POC.render.normalizeTag(tag);

        return (
          normalizedTag === "curated_package" ||
          normalizedTag === "catalog_badge_package" ||
          normalizedTag === "package" ||
          normalizedTag === "packages" ||
          normalizedTag === "package_deal" ||
          normalizedTag === "package_deals" ||
          normalizedTag.indexOf("curated_package") === 0 ||
          normalizedTag.indexOf("catalog_badge_package") === 0 ||
          normalizedTag.indexOf("package_") === 0
        );
      });
    }

    return normalizedLabelTexts.indexOf(selectedLabel) >= 0;
  },

  getProductDetailCandidate(product) {
    if (!product) return null;

    var productId = product && product.id != null ? String(product.id) : "";
    if (productId && POC.state && POC.state.productDetailCache && POC.state.productDetailCache[productId]) {
      return POC.state.productDetailCache[productId];
    }

    return product;
  },

  getProductBrandValue(product) {
    var detail = this.getProductDetailCandidate(product);
    return String(
      (detail && (detail.brand || detail.Brand || detail.manufacturerName || detail.ManufacturerName)) ||
      (product && (product.brand || product.Brand || product.manufacturerName || product.ManufacturerName)) ||
      ""
    ).trim();
  },

  getProductManufacturerSkuValue(product) {
    var detail = this.getProductDetailCandidate(product);

    return String(
      (detail && (
        detail.manufacturerSku ||
        detail.manufacturerSKU ||
        detail.ManufacturerSku ||
        detail.ManufacturerSKU ||
        detail.manufacturerStyleCode ||
        detail.ManufacturerStyleCode ||
        detail.supplierSku ||
        detail.SupplierSku ||
        detail.rawManufacturerSku ||
        detail.RawManufacturerSku
      )) ||
      (detail && detail.raw && (
        detail.raw.manufacturerSku ||
        detail.raw.manufacturerSKU ||
        detail.raw.ManufacturerSku ||
        detail.raw.ManufacturerSKU ||
        detail.raw.manufacturerStyleCode ||
        detail.raw.ManufacturerStyleCode ||
        detail.raw.supplierSku ||
        detail.raw.SupplierSku
      )) ||
      (product && (
        product.manufacturerSku ||
        product.manufacturerSKU ||
        product.ManufacturerSku ||
        product.ManufacturerSKU ||
        product.manufacturerStyleCode ||
        product.ManufacturerStyleCode ||
        product.supplierSku ||
        product.SupplierSku
      )) ||
      (product && product.raw && (
        product.raw.manufacturerSku ||
        product.raw.manufacturerSKU ||
        product.raw.ManufacturerSku ||
        product.raw.ManufacturerSKU ||
        product.raw.manufacturerStyleCode ||
        product.raw.ManufacturerStyleCode ||
        product.raw.supplierSku ||
        product.raw.SupplierSku
      )) ||
      ""
    ).trim();
  },

  getProductStyleEntries(product) {
    if (!product) return [];

    var buckets = [
      product.styles,
      product.Styles,
      product.styleList,
      product.StyleList,
      product.colorways,
      product.Colorways,
      product.raw && product.raw.styles,
      product.raw && product.raw.Styles,
      product.raw && product.raw.styleList,
      product.raw && product.raw.StyleList,
      product.raw && product.raw.raw && product.raw.raw.styles,
      product.raw && product.raw.raw && product.raw.raw.Styles,
      product.data && product.data.styles,
      product.data && product.data.Styles,
      product.data && product.data.styleList,
      product.data && product.data.StyleList,
      product.data && product.data.raw && product.data.raw.styles,
      product.data && product.data.raw && product.data.raw.Styles
    ];

    var styles = [];

    buckets.forEach(function (bucket) {
      if (Array.isArray(bucket) && bucket.length) {
        styles = styles.concat(bucket);
      }
    });

    return styles;
  },

  normalizeHexColor(value) {
    var color = String(value || "").trim().replace(/^#/, "");
    if (!color) return "";
    if (!/^([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color)) return "";
    return "#" + color.toUpperCase();
  },

  humanizeColorName(value) {
    var text = String(value || "").trim();
    if (!text) return "";

    if (text.indexOf("-") >= 0 || text.indexOf("/") >= 0) {
      return text
        .split(/([\-\/])/)
        .map(function (part) {
          if (part === "-" || part === "/") return part;
          return part.toLowerCase().replace(/\b[a-z]/g, function (m) { return m.toUpperCase(); });
        })
        .join("");
    }

    return text.toLowerCase().replace(/\b[a-z]/g, function (m) { return m.toUpperCase(); });
  },

  getStyleDisplayName(style) {
    var raw = String(
      (style && (
        style.name ||
        style.Name ||
        style.colorName ||
        style.ColorName ||
        style.color ||
        style.Color ||
        style.code ||
        style.Code
      )) || ""
    ).trim();

    return this.humanizeColorName(raw);
  },


  getStyleIdValue(style, fallbackIndex) {
    var value = String(
      (style && (
        style.id ||
        style.ID ||
        style.Id ||
        style.styleId ||
        style.StyleId ||
        style.StyleID ||
        style.productStyleId ||
        style.ProductStyleId ||
        style.ProductStyleID ||
        style.BaseStyleId ||
        style.BaseStyleID
      )) || ""
    ).trim();

    if (value) return value;
    return fallbackIndex == null ? "" : String(fallbackIndex);
  },

  getStyleImageUrl(style, product) {
    function firstValue() {
      for (var i = 0; i < arguments.length; i += 1) {
        var value = String(arguments[i] || "").trim();
        if (value) return value;
      }
      return "";
    }

    var sides = [];
    if (style && Array.isArray(style.sides)) sides = sides.concat(style.sides);
    if (style && Array.isArray(style.Sides)) sides = sides.concat(style.Sides);

    for (var i = 0; i < sides.length; i += 1) {
      var side = sides[i] || {};
      var sideName = String(side.side || side.Side || side.name || side.Name || "").toLowerCase();
      var image = firstValue(
        side.imageUrl,
        side.ImageUrl,
        side.thumbnailUrl,
        side.ThumbnailUrl,
        side.url,
        side.Url
      );

      if (image && (!sideName || sideName.indexOf("front") !== -1 || i === 0)) {
        return image;
      }
    }

    return firstValue(
      style && style.imageUrl,
      style && style.ImageUrl,
      style && style.thumbnailUrl,
      style && style.ThumbnailUrl,
      style && style.primaryImage,
      style && style.PrimaryImage,
      product && product.thumbnailUrl,
      product && product.ThumbnailUrl,
      product && product.primaryImage,
      product && product.PrimaryImage,
      product && product.imageUrl,
      product && product.ImageUrl
    );
  },

  getVariantSummaryColorNames(product) {
    var detail = this.getProductDetailCandidate(product);
    var raw = [];

    if (detail && detail.variantSummary && Array.isArray(detail.variantSummary.colors)) {
      raw = detail.variantSummary.colors.slice();
    } else if (detail && Array.isArray(detail.colors)) {
      raw = detail.colors.slice();
    } else if (product && product.variantSummary && Array.isArray(product.variantSummary.colors)) {
      raw = product.variantSummary.colors.slice();
    }

    return raw.map(function (item) {
      if (typeof item === "string") return POC.render.humanizeColorName(item);
      if (item && typeof item === "object") {
        return POC.render.humanizeColorName(
          item.name || item.Name || item.color || item.Color || item.label || item.Label || ""
        );
      }
      return "";
    }).filter(Boolean);
  },

  getExpectedColorOptionCount(product) {
    var detail = this.getProductDetailCandidate(product);

    if (detail && detail.variantSummary && typeof detail.variantSummary.colorCount === "number") {
      return Number(detail.variantSummary.colorCount) || 0;
    }

    if (product && product.variantSummary && typeof product.variantSummary.colorCount === "number") {
      return Number(product.variantSummary.colorCount) || 0;
    }

    var styles = this.getProductStyleEntries(detail);
    if (styles.length) return styles.length;

    var names = this.getVariantSummaryColorNames(product);
    if (names.length) return names.length;

    return 0;
  },

  getProductColorOptions(product) {
    var detail = this.getProductDetailCandidate(product);
    var styles = this.getProductStyleEntries(detail);
    var seen = {};
    var options = [];

    styles.forEach(function (style, index) {
      var name = POC.render.getStyleDisplayName(style);
      var c1 = POC.render.normalizeHexColor(style && (style.htmlColor1 || style.HtmlColor1));
      var c2 = POC.render.normalizeHexColor(style && (style.htmlColor2 || style.HtmlColor2));
      var styleId = POC.render.getStyleIdValue(style, index);
      var imageUrl = POC.render.getStyleImageUrl(style, detail || product);

      if (!name && !c1 && !c2) return;

      var key = String((styleId || "") + "|" + (name || "") + "|" + (c1 || "") + "|" + (c2 || "")).toLowerCase();
      if (seen[key]) return;
      seen[key] = true;

      options.push({
        name: name || "Color Option",
        color1: c1,
        color2: c2,
        styleId: styleId,
        imageUrl: imageUrl,
        thumbnailUrl: imageUrl
      });
    });

    if (!options.length) {
      this.getVariantSummaryColorNames(detail || product).forEach(function (name) {
        var key = String(name || "").toLowerCase();
        if (!key || seen[key]) return;
        seen[key] = true;

        options.push({
          name: name,
          color1: "",
          color2: "",
          styleId: "",
          imageUrl: "",
          thumbnailUrl: ""
        });
      });
    }

    return options;
  },

  getProductColorNames(product) {
    return this.getProductColorOptions(product).map(function (item) {
      return item.name;
    });
  },

  getProductSizeLabels(product) {
    var detail = this.getProductDetailCandidate(product);
    var styles = this.getProductStyleEntries(detail);
    var seen = {};
    var sizes = [];

    styles.forEach(function (style) {
      var styleSizes = []
        .concat(Array.isArray(style && style.sizes) ? style.sizes : [])
        .concat(Array.isArray(style && style.Sizes) ? style.Sizes : []);

      styleSizes.forEach(function (size) {
        var raw = String(
          (size && (size.name || size.Name || size.label || size.Label || size.code || size.Code || size.size || size.Size)) || ""
        ).trim();

        if (!raw) return;

        var key = raw.toLowerCase();
        if (seen[key]) return;
        seen[key] = true;
        sizes.push(raw);
      });
    });

    if (!sizes.length) {
      var productSizes = []
        .concat(Array.isArray(detail && detail.sizes) ? detail.sizes : [])
        .concat(Array.isArray(detail && detail.Sizes) ? detail.Sizes : []);

      productSizes.forEach(function (size) {
        var raw = String(
          (size && (size.name || size.Name || size.label || size.Label || size.code || size.Code || size.size || size.Size)) || ""
        ).trim();

        if (!raw) return;

        var key = raw.toLowerCase();
        if (seen[key]) return;
        seen[key] = true;
        sizes.push(raw);
      });
    }

    return sizes;
  },

  getProductDescriptionText(product) {
    var detail = this.getProductDetailCandidate(product);
    var raw = "";

    if (detail && detail.description) raw = detail.description;
    else if (detail && detail.Description) raw = detail.Description;
    else if (product && product.description) raw = product.description;
    else if (product && product.Description) raw = product.Description;

    raw = String(raw || "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return raw;
  },

  getProductDescriptionHtml(product) {
    var detail = this.getProductDetailCandidate(product);
    var raw = "";

    if (detail && detail.description) raw = detail.description;
    else if (detail && detail.Description) raw = detail.Description;
    else if (product && product.description) raw = product.description;
    else if (product && product.Description) raw = product.Description;

    raw = String(raw || "").trim();
    if (!raw) return "";

    return POC.ui.sanitizeHtml(raw);
  },

  matchesBrandFilter(product) {
    var filters = POC.state.filters || {};
    var selected = this.normalizeText(filters.brand || "");
    if (!selected) return true;

    return this.normalizeText(this.getProductBrandValue(product)) === selected;
  },

  matchesColorFilter(product) {
    var filters = POC.state.filters || {};
    var selected = this.normalizeText(filters.color || "");
    if (!selected) return true;

    var colors = this.getProductColorNames(product).map(this.normalizeText.bind(this));
    return colors.indexOf(selected) >= 0;
  },

  matchesSizeFilter(product) {
    var filters = POC.state.filters || {};
    var selected = this.normalizeText(filters.size || "");
    if (!selected) return true;

    var sizes = this.getProductSizeLabels(product).map(this.normalizeText.bind(this));
    return sizes.indexOf(selected) >= 0;
  },

  getFilterOptions(products) {
    var self = this;
    var brandsSeen = {};
    var colorsSeen = {};
    var sizesSeen = {};
    var brands = [];
    var colors = [];
    var sizes = [];

    (Array.isArray(products) ? products : []).forEach(function (product) {
      var brand = self.getProductBrandValue(product);
      var brandKey = self.normalizeText(brand);
      if (brandKey && !brandsSeen[brandKey]) {
        brandsSeen[brandKey] = true;
        brands.push(brand);
      }

      self.getProductColorNames(product).forEach(function (color) {
        var key = self.normalizeText(color);
        if (!key || colorsSeen[key]) return;
        colorsSeen[key] = true;
        colors.push(color);
      });

      self.getProductSizeLabels(product).forEach(function (size) {
        var key = self.normalizeText(size);
        if (!key || sizesSeen[key]) return;
        sizesSeen[key] = true;
        sizes.push(size);
      });
    });

    brands.sort(function (a, b) { return String(a).localeCompare(String(b)); });
    colors.sort(function (a, b) { return String(a).localeCompare(String(b)); });
    sizes.sort(function (a, b) { return String(a).localeCompare(String(b)); });

    return {
      brands: brands,
      colors: colors,
      sizes: sizes
    };
  },

  syncPresetChipActiveState(activeContext) {
    var filters =
      POC.state && POC.state.filters
        ? POC.state.filters
        : {};

    var selectedFilter = String(
      filters.curatedFilter || "ALL"
    ).toUpperCase();

    var packageIsActive = !!(
      activeContext && activeContext.packageName
    ) || (
      selectedFilter === "PACKAGE" ||
      selectedFilter === "PACKAGES" ||
      selectedFilter === "PACKAGE DEAL" ||
      selectedFilter === "PACKAGE DEALS"
    );

    Array.prototype.forEach.call(
      document.querySelectorAll("[data-curated-filter]"),
      function (button) {
        var buttonValue = String(
          button.getAttribute("data-curated-filter") || "ALL"
        ).toUpperCase();

        var buttonIsPackage =
          buttonValue === "PACKAGE" ||
          buttonValue === "PACKAGES" ||
          buttonValue === "PACKAGE DEAL" ||
          buttonValue === "PACKAGE DEALS";

        var shouldBeActive = buttonIsPackage
          ? packageIsActive
          : !packageIsActive && buttonValue === selectedFilter;

        button.classList.toggle("is-active", shouldBeActive);
        button.setAttribute(
          "aria-pressed",
          shouldBeActive ? "true" : "false"
        );
      }
    );
  },

  renderFilterOptions(products, filteredProducts) {
    var brandEl = document.getElementById("poc-demo-filter-brand");
    var colorEl = document.getElementById("poc-demo-filter-color");
    var sizeEl = document.getElementById("poc-demo-filter-size");

    var options = this.getFilterOptions(products);
    var filteredOptions = this.getFilterOptions(
      Array.isArray(filteredProducts) ? filteredProducts : products
    );
    var filters = POC.state.filters || {};

    function buildOptions(list, placeholder, selectedValue) {
      var current = String(selectedValue || "");
      return ''
        + '<option value="">' + POC.ui.escapeHtml(placeholder) + '</option>'
        + list.map(function (value) {
            var text = String(value || "");
            return '<option value="' + POC.ui.escapeHtml(text) + '"' + (text === current ? ' selected' : '') + '>' + POC.ui.escapeHtml(text) + '</option>';
          }).join('');
    }

    if (brandEl) {
      brandEl.innerHTML = buildOptions(
        filteredOptions.brands,
        "By Brand",
        filters.brand || ""
      );
    }

    if (colorEl) {
      colorEl.innerHTML = buildOptions(options.colors, "By Color", filters.color || "");
    }

    if (sizeEl) {
      sizeEl.innerHTML = buildOptions(options.sizes, "By Size", filters.size || "");
    }
  },

  hasActiveProductFilters() {
    var filters = POC.state && POC.state.filters
      ? POC.state.filters
      : {};

    return !!(
      String(filters.search || "").trim() ||
      filters.curatedOnly === true ||
      (filters.curatedFilter && filters.curatedFilter !== "ALL") ||
      String(filters.brand || "").trim() ||
      String(filters.color || "").trim() ||
      String(filters.size || "").trim()
    );
  },

  filterProducts(products) {
    var source = Array.isArray(products) ? products : [];

    // The category API response is authoritative. When the toolbar is in its
    // default state, do not run the products through any secondary filters.
    if (!this.hasActiveProductFilters()) {
      return source.slice();
    }

    var self = this;
    var filters = POC.state.filters || {};
    var searchTerm = this.normalizeText(filters.search || "");

    return source.filter(function (product) {
      return self.matchesSearch(product, searchTerm)
        && self.matchesCuratedFilters(product)
        && self.matchesBrandFilter(product)
        && self.matchesColorFilter(product)
        && self.matchesSizeFilter(product);
    });
  },

  sortProducts(products) {
    var self = this;

    return (Array.isArray(products) ? products.slice() : []).sort(function (a, b) {
      var aCurated = self.isCurated(a) ? 1 : 0;
      var bCurated = self.isCurated(b) ? 1 : 0;

      if (aCurated !== bCurated) {
        return bCurated - aCurated;
      }

      var aRank = self.getCuratedRank(a);
      var bRank = self.getCuratedRank(b);

      if (aRank !== bRank) {
        return aRank - bRank;
      }

      var aName = String((a && a.name) || "").toLowerCase();
      var bName = String((b && b.name) || "").toLowerCase();

      return aName.localeCompare(bName);
    });
  },

  getCategoryChildren(category) {
    if (!category) return [];

    var children = [];
    if (Array.isArray(category.children)) children = children.concat(category.children);
    if (Array.isArray(category.Children)) children = children.concat(category.Children);
    if (Array.isArray(category.subCategories)) children = children.concat(category.subCategories);
    if (Array.isArray(category.SubCategories)) children = children.concat(category.SubCategories);

    return children.filter(function (child) {
      return !!child && (
        child.id != null ||
        child.CategoryId != null ||
        child.name ||
        child.Name ||
        child.CategoryName ||
        child.categoryName
      );
    });
  },

  isCategoryExpanded(category) {
    this.ensureCategoryTreeState();
    var id = category && category.id != null ? String(category.id) : "";
    if (!id) return false;
    return !!POC.state.categoryTree.expanded[id];
  },

  toggleCategoryExpanded(categoryId) {
    this.ensureCategoryTreeState();

    var id = String(categoryId || "");
    if (!id) return;

    POC.state.categoryTree.expanded[id] = !POC.state.categoryTree.expanded[id];
    this.renderCategories(POC.state.categories || []);
  },

  getTreeMetrics() {
    return {
      baseIndent: 10,
      depthIndent: 14,
      toggleSize: 20,
      toggleGap: 8
    };
  },

  buildToggleButton(id, expanded) {
    var m = this.getTreeMetrics();

    return '' +
      '<button type="button" class="poc-demo-tree__toggle" data-category-toggle="' + POC.ui.escapeHtml(id) + '" aria-label="' + (expanded ? "Collapse" : "Expand") + '"' +
      ' style="display:inline-flex;width:' + m.toggleSize + 'px;min-width:' + m.toggleSize + 'px;height:' + m.toggleSize + 'px;align-items:center;justify-content:center;flex:0 0 ' + m.toggleSize + 'px;margin-right:' + m.toggleGap + 'px;border:1px solid #b9c2d0;border-radius:4px;background:#fff;color:#23314f;padding:0;line-height:1;">' +
        '<span class="poc-demo-tree__toggle-icon" style="font-size:14px;font-weight:700;line-height:1;">' + (expanded ? "−" : "+") + '</span>' +
      '</button>';
  },

  buildToggleSpacer() {
    var m = this.getTreeMetrics();

    return '' +
      '<span aria-hidden="true" style="display:inline-flex;width:' + m.toggleSize + 'px;min-width:' + m.toggleSize + 'px;height:' + m.toggleSize + 'px;align-items:center;justify-content:center;flex:0 0 ' + m.toggleSize + 'px;margin-right:' + m.toggleGap + 'px;"></span>';
  },

  buildCategoryNodeHtml(category, depth) {
    var self = this;
    var m = this.getTreeMetrics();

    var id =
      category && (category.id != null || category.CategoryId != null)
        ? String(category.id != null ? category.id : category.CategoryId)
        : "";

    var sourceName =
      category && (category.name || category.Name || category.CategoryName || category.categoryName)
        ? (category.name || category.Name || category.CategoryName || category.categoryName)
        : "Unnamed Category";

    var displayName = self.getCategoryDisplayName(sourceName);

    var count = category && category.itemCount != null
      ? Number(category.itemCount)
      : category && category.ItemCount != null
        ? Number(category.ItemCount)
        : category && category.count != null
          ? Number(category.count)
          : category && category.Count != null
            ? Number(category.Count)
            : 0;

    var children = self.getCategoryChildren(category);
    var hasChildren = children.length > 0;
    var expanded = hasChildren ? self.isCategoryExpanded(category) : false;
    var isActive = String(id) === String(POC.state.selectedCategoryId || "ALL");

    var indent = m.baseIndent + (depth * m.depthIndent);
    var toggleHtml = hasChildren ? self.buildToggleButton(id, expanded) : self.buildToggleSpacer();

    var html =
      '<button type="button" class="poc-demo-tree__leaf' + (isActive ? ' is-active' : '') + '"' +
      ' data-category-id="' + POC.ui.escapeHtml(id) + '"' +
      ' data-category-name="' + POC.ui.escapeHtml(sourceName) + '"' +
      ' data-category-display-name="' + POC.ui.escapeHtml(displayName) + '"' +
      ' style="padding:10px 12px 10px ' + indent + 'px;display:flex;align-items:center;gap:0;">' +
        toggleHtml +
        '<span class="poc-demo-tree__label" style="display:block;line-height:1.35;">' +
          POC.ui.escapeHtml(displayName) +
          '<span class="poc-demo-tree__count" data-category-count="' + POC.ui.escapeHtml(id) + '">' + (count > 0 ? '(' + POC.ui.escapeHtml(count) + ')' : '') + '</span>' +
        '</span>' +
      '</button>';

    if (hasChildren && expanded) {
      html += children.map(function (child) {
        return self.buildCategoryNodeHtml(child, depth + 1);
      }).join("");
    }

    return html;
  },

    buildBadgeHtml(product) {
    var labels = this.getCuratedLabels(product);
    if (!labels.length) return "";

    /*
      Render multiple current badges in one visible row.

      PACKAGE intentionally uses a unique CSS class and explicit inline styling
      because an older theme rule for `.poc-demo-card__badge--package` can hide
      or overlap that badge even when `curated_package` is correctly detected.
    */
    return (
      '<div class="poc-demo-card__badges poc-demo-card__badges--multi"' +
        ' style="position:absolute!important;top:8px!important;left:8px!important;' +
        'right:8px!important;z-index:6!important;display:flex!important;' +
        'align-items:center!important;justify-content:center!important;' +
        'gap:6px!important;flex-wrap:wrap!important;pointer-events:none!important;">' +
      labels.map(function (label) {
        var isPackage = label && label.text === "PACKAGE";
        var safeClass = isPackage ? "package-visible" : label.className;
        var packageStyle = isPackage
          ? 'background:#dce8fb!important;color:#244f86!important;border:1px solid #b9cce8!important;'
          : '';

        return (
          '<div class="poc-demo-card__badge poc-demo-card__badge--' +
          POC.ui.escapeHtml(safeClass) +
          '" style="position:static!important;inset:auto!important;transform:none!important;' +
          'margin:0!important;display:inline-flex!important;visibility:visible!important;' +
          'opacity:1!important;align-items:center!important;justify-content:center!important;' +
          packageStyle +
          '">' +
          POC.ui.escapeHtml(label.text) +
          "</div>"
        );
      }).join("") +
      "</div>"
    );
  },

  buildProductSwatchesHtml(product) {
    var productId = product && product.id != null ? String(product.id) : "";
    var cached = this.getProductColorOptions(product);

    if (cached.length > 1 || this.getExpectedColorOptionCount(product) > 1) {
      return '' +
        '<div class="poc-demo-card__swatches-wrap" data-card-swatches="' + POC.ui.escapeHtml(productId) + '">' +
          this.renderSwatchMarkup(cached, productId) +
        '</div>';
    }

    return '<div class="poc-demo-card__swatches-wrap" data-card-swatches="' + POC.ui.escapeHtml(productId) + '"></div>';
  },

  buildProductDetailUrl(productId, options) {
    options = options || {};
    var id = String(productId || "").trim();
    if (!id) return "/pages/inksoft-product";

    var params = new URLSearchParams();
    params.set("id", id);

    if (options.styleId) {
      params.set("styleId", String(options.styleId));
    }

    if (options.selectedColor) {
      params.set("selectedColor", String(options.selectedColor));
    }

    return "/pages/inksoft-product?" + params.toString();
  },

  renderSwatchMarkup(colorOptions, productId) {
    if (!Array.isArray(colorOptions) || !colorOptions.length) {
      return "";
    }

    var maxVisible = 12;
    var visible = colorOptions.slice(0, maxVisible);
    var remaining = Math.max(0, colorOptions.length - visible.length);
    var safeProductId = String(productId || "");

    return '' +
      '<div class="poc-demo-card__swatches">' +
        visible.map(function (item, index) {
          var bg = item.color1 || item.color2 || "#D9DEE7";
          var bgStyle = item.color1 && item.color2 && item.color1 !== item.color2
            ? 'linear-gradient(135deg, ' + item.color1 + ' 0%, ' + item.color1 + ' 48%, ' + item.color2 + ' 52%, ' + item.color2 + ' 100%)'
            : bg;
          var name = item.name || "Color Option";
          var styleId = item.styleId || "";
          var imageUrl = item.imageUrl || item.thumbnailUrl || "";
          var detailUrl = POC.render.buildProductDetailUrl(safeProductId, {
            styleId: styleId,
            selectedColor: name
          });

          return '' +
            '<button type="button" class="poc-demo-card__swatch' + (index === 0 ? ' is-active' : '') + '"' +
              ' title="' + POC.ui.escapeHtml(name) + '"' +
              ' aria-label="Show ' + POC.ui.escapeHtml(name) + '"' +
              ' data-card-swatch="true"' +
              ' data-product-id="' + POC.ui.escapeHtml(safeProductId) + '"' +
              ' data-style-id="' + POC.ui.escapeHtml(styleId) + '"' +
              ' data-color-name="' + POC.ui.escapeHtml(name) + '"' +
              ' data-image-url="' + POC.ui.escapeHtml(imageUrl) + '"' +
              ' data-detail-url="' + POC.ui.escapeHtml(detailUrl) + '">' +
              '<span class="poc-demo-card__swatch-inner" style="background:' + POC.ui.escapeHtml(bgStyle) + ';"></span>' +
            '</button>';
        }).join('') +
      '</div>' +
      (remaining > 0
        ? '<a class="poc-demo-card__swatches-more" href="' + POC.ui.escapeHtml(POC.render.buildProductDetailUrl(safeProductId)) + '">+ ' + POC.ui.escapeHtml(remaining) + ' more colors</a>'
        : '');
  },

  buildProductMetaSummary(product) {
    var sku = product && product.sku ? String(product.sku) : "";
    var brand = product && product.brand ? String(product.brand) : "";

    if (!sku && !brand) return "";

    return '' +
      (sku
        ? '<span class="ua-product-meta-sku">' + POC.ui.escapeHtml(sku) + '</span>'
        : '') +
      (sku && brand
        ? ' <span class="ua-product-meta-separator poc-demo-card__meta-sep">|</span> '
        : '') +
      (brand
        ? '<span class="ua-product-meta-brand">' + POC.ui.escapeHtml(brand) + '</span>'
        : '');
  },


  buildRequestQuoteUrl(product, options) {
    options = options || {};

    var detail = this.getProductDetailCandidate(product) || product || {};
    var productId = detail && detail.id != null
      ? String(detail.id)
      : product && product.id != null
        ? String(product.id)
        : "";

    var productName = String(
      (detail && (detail.name || detail.Name)) ||
      (product && (product.name || product.Name)) ||
      ""
    ).trim();

    var manufacturerSku = this.getProductManufacturerSkuValue(detail || product);

    var selectedStyleId = String(
      options.selectedStyleId ||
      (options.selectedStyle && options.selectedStyle.id) ||
      ""
    ).trim();

    var selectedColor = String(
      options.selectedColor ||
      (options.selectedStyle && options.selectedStyle.name) ||
      ""
    ).trim();

    var productImageUrl = String(
      options.productImageUrl ||
      (options.selectedView && (options.selectedView.imageUrl || options.selectedView.thumbnailUrl)) ||
      (options.selectedStyle && (options.selectedStyle.imageUrl || options.selectedStyle.thumbnailUrl)) ||
      detail.primaryImage ||
      detail.thumbnailUrl ||
      product.thumbnailUrl ||
      ""
    ).trim();

    var params = new URLSearchParams();

    if (productId) params.set("productId", productId);
    if (productName) params.set("productName", productName);
    if (manufacturerSku) params.set("manufacturerSku", manufacturerSku);
    if (selectedStyleId) params.set("selectedStyleId", selectedStyleId);
    if (selectedColor) params.set("selectedColor", selectedColor);
    if (productImageUrl) params.set("productImageUrl", productImageUrl);

    params.set("sourcePageUrl", window.location.href);

    return "/pages/request-a-quote?" + params.toString();
  },

  buildProductCard(product) {
    var id = product && product.id != null ? String(product.id) : "";
    var name = product && product.name ? product.name : "Unnamed Product";
    var thumbnailUrl = product && product.thumbnailUrl ? product.thumbnailUrl : "";
    var badgesHtml = this.buildBadgeHtml(product);
    var swatchesHtml = this.buildProductSwatchesHtml(product);
    var metaSummary = this.buildProductMetaSummary(product);
    var detailUrl = this.buildProductDetailUrl(id);
    var isCompareSelected = POC.core && POC.core.isCompareSelected ? POC.core.isCompareSelected(id) : false;

    return '' +
      '<div class="poc-demo-card" data-product-id="' + POC.ui.escapeHtml(id) + '">' +
        badgesHtml +
        (thumbnailUrl
          ? '<a class="poc-demo-card__thumb-wrap poc-demo-card__thumb-link" href="' + POC.ui.escapeHtml(detailUrl) + '" data-card-detail-link="true">' +
              '<img class="poc-demo-card__thumb" src="' + POC.ui.escapeHtml(thumbnailUrl) + '" alt="' + POC.ui.escapeHtml(name) + '" loading="lazy" width="230" height="220" onerror="this.style.display=\'none\';">' +
            '</a>'
          : '<a class="poc-demo-card__thumb-wrap poc-demo-card__thumb-link" href="' + POC.ui.escapeHtml(detailUrl) + '" data-card-detail-link="true"><div class="poc-demo-empty">No image available.</div></a>') +
        '<div class="poc-demo-card__title"><a class="poc-demo-card__title-link" href="' + POC.ui.escapeHtml(detailUrl) + '" data-card-detail-link="true">' + POC.ui.escapeHtml(name) + '</a></div>' +
        (metaSummary ? '<div class="poc-demo-card__meta-summary">' + metaSummary + '</div>' : '') +
        swatchesHtml +
        '<div class="poc-demo-card__actions">' +
          '<button type="button" class="poc-demo-action-button poc-demo-action-button--compare' + (isCompareSelected ? ' is-selected' : '') + '" data-compare-toggle="' + POC.ui.escapeHtml(id) + '">' + (isCompareSelected ? 'Remove Compare' : 'Compare') + '</button>' +
        '</div>' +
      '</div>';
  },

  ensureDetailCache() {
    this.ensureCategoryTreeState();
    if (!POC.state.productDetailCache) POC.state.productDetailCache = {};
    if (!POC.state.productDetailInflight) POC.state.productDetailInflight = {};
  },

  fetchProductDetail(productId) {
    var self = this;
    self.ensureDetailCache();

    var id = String(productId || "");
    if (!id) return Promise.resolve(null);

    if (POC.state.productDetailCache[id]) {
      return Promise.resolve(POC.state.productDetailCache[id]);
    }

    if (POC.state.productDetailInflight[id]) {
      return POC.state.productDetailInflight[id];
    }

    var promise = POC.api.getProductDetail(id)
      .then(function (detail) {
        if (detail) {
          POC.state.productDetailCache[id] = detail;
        }
        delete POC.state.productDetailInflight[id];
        return detail;
      })
      .catch(function (error) {
        delete POC.state.productDetailInflight[id];
        console.error("[POC] detail hydrate failed", id, error);
        return null;
      });

    POC.state.productDetailInflight[id] = promise;
    return promise;
  },

  getSafeDomSelector(value) {
    var text = String(value || "");
    if (window.CSS && typeof window.CSS.escape === "function") {
      return CSS.escape(text);
    }
    return text.replace(/"/g, '\\"');
  },

  findSwatchContainer(productId, scopeRoot) {
    var selector = '[data-card-swatches="' + this.getSafeDomSelector(productId) + '"]';
    var root = scopeRoot || document;
    return root.querySelector(selector);
  },

  renderSwatchesToCard(productId, colorOptions, options) {
    options = options || {};
    var scopeRoot = options.scopeRoot || document;
    var renderCycleId = options.renderCycleId;
    var target = this.findSwatchContainer(productId, scopeRoot);

    if (!target) return;

    if (renderCycleId != null) {
      var currentCycle = String(target.getAttribute("data-render-cycle") || "");
      if (currentCycle && currentCycle !== String(renderCycleId)) {
        return;
      }
    }

    target.innerHTML = this.renderSwatchMarkup(colorOptions, productId);
    this.bindCardSwatchEvents(scopeRoot);
  },

  hydrateVisibleCardSwatches(products, options) {
    var self = this;
    options = options || {};

    var scopeRoot = options.scopeRoot || document;
    var renderCycleId = options.renderCycleId;

    var cards = Array.prototype.slice.call(
      scopeRoot.querySelectorAll(".poc-demo-card[data-product-id]")
    );

    cards.forEach(function (card) {
      var productId = String(card.getAttribute("data-product-id") || "");
      if (!productId) return;

      var swatchContainer = card.querySelector("[data-card-swatches]");
      if (!swatchContainer) return;

      if (renderCycleId != null) {
        swatchContainer.setAttribute("data-render-cycle", String(renderCycleId));
      }

      var sourceProduct = null;

      if (POC.state && POC.state.productDetailCache && POC.state.productDetailCache[productId]) {
        sourceProduct = POC.state.productDetailCache[productId];
      }

      if (!sourceProduct && Array.isArray(products)) {
        for (var i = 0; i < products.length; i += 1) {
          var id = products[i] && products[i].id != null ? String(products[i].id) : "";
          if (id === productId) {
            sourceProduct = products[i];
            break;
          }
        }
      }

      var existingOptions = self.getProductColorOptions(sourceProduct);
      var expectedCount = self.getExpectedColorOptionCount(sourceProduct);

      if (existingOptions.length > 1 && (!expectedCount || existingOptions.length >= expectedCount)) {
        self.renderSwatchesToCard(productId, existingOptions, {
          scopeRoot: scopeRoot,
          renderCycleId: renderCycleId
        });
        return;
      }

      self.fetchProductDetail(productId).then(function (detail) {
        if (!detail) return;

        var detailOptions = self.getProductColorOptions(detail);
        if (!detailOptions.length) return;

        self.renderSwatchesToCard(productId, detailOptions, {
          scopeRoot: scopeRoot,
          renderCycleId: renderCycleId
        });
      });
    });
  },

  bindCardSwatchEvents(scopeRoot) {
    var root = scopeRoot || document;

    /*
      Mobile catalogue swatches are availability indicators only.

      Do not:
      - bind one listener per swatch;
      - change the card image;
      - update the card detail URL;
      - mark swatches as interactive.

      Desktop retains the existing preview behaviour.
    */
    if (this.isMobileCatalogue()) {
      Array.prototype.forEach.call(
        root.querySelectorAll("[data-card-swatch]"),
        function (swatch) {
          swatch.removeAttribute("aria-pressed");
          swatch.setAttribute("tabindex", "-1");
          swatch.setAttribute("aria-disabled", "true");
        }
      );

      return;
    }

    Array.prototype.forEach.call(
      root.querySelectorAll("[data-card-swatch]"),
      function (button) {
        if (button.dataset.boundCatalogSwatch) return;

        button.dataset.boundCatalogSwatch = "true";

        button.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          var card = button.closest(".poc-demo-card[data-product-id]");
          if (!card) return;

          var imageUrl = button.getAttribute("data-image-url") || "";
          var detailUrl = button.getAttribute("data-detail-url") || "";
          var colorName = button.getAttribute("data-color-name") || "";

          Array.prototype.forEach.call(
            card.querySelectorAll("[data-card-swatch]"),
            function (swatch) {
              var isSelected = swatch === button;

              swatch.classList.toggle("is-active", isSelected);
              swatch.setAttribute(
                "aria-pressed",
                isSelected ? "true" : "false"
              );
            }
          );

          if (imageUrl) {
            var img = card.querySelector(".poc-demo-card__thumb");

            if (img) {
              img.style.display = "";
              img.src = imageUrl;

              if (colorName) {
                img.alt = (img.alt || "Product") + " - " + colorName;
              }
            }
          }

          if (detailUrl) {
            Array.prototype.forEach.call(
              card.querySelectorAll("[data-card-detail-link]"),
              function (link) {
                link.setAttribute("href", detailUrl);
              }
            );
          }
        });
      }
    );
  },

  scheduleVisibleCardSwatchHydration(products, options) {
    /*
      Mobile cards use only the colour data already included in the
      catalogue payload.

      Do not fetch full product details merely to hydrate additional
      swatches. Customers can see complete colour selections on the
      product-detail page.

      Desktop retains the existing hydration workflow.
    */
    if (this.isMobileCatalogue()) {
      return;
    }

    var self = this;
    options = options || {};

    if (typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          self.hydrateVisibleCardSwatches(products, options);
        });
      });

      return;
    }

    setTimeout(function () {
      self.hydrateVisibleCardSwatches(products, options);
    }, 0);
  },

  getPayloadProducts(payload) {
    if (!payload) return [];

    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload.products)) return payload.products;
    if (Array.isArray(payload.items)) return payload.items;
    if (Array.isArray(payload.results)) return payload.results;

    if (payload.data && typeof payload.data === "object") {
      if (Array.isArray(payload.data.data)) return payload.data.data;
      if (Array.isArray(payload.data.products)) return payload.data.products;
      if (Array.isArray(payload.data.items)) return payload.data.items;
      if (Array.isArray(payload.data.results)) return payload.data.results;
    }

    var curated = Array.isArray(payload.curated) ? payload.curated : [];
    var regular = Array.isArray(payload.regular) ? payload.regular : [];
    return curated.concat(regular);
  },

  ensureLoadMoreContainer(gridEl) {
    var wrap = document.getElementById("poc-demo-load-more-wrap");
    if (wrap) return wrap;

    wrap = document.createElement("div");
    wrap.id = "poc-demo-load-more-wrap";
    wrap.className = "poc-demo-load-more-wrap";

    if (gridEl && gridEl.parentNode) {
      gridEl.parentNode.insertBefore(wrap, gridEl.nextSibling);
    }

    return wrap;
  },

  renderLoadMore(totalCount, visibleCount) {
    var gridEl = document.getElementById("poc-demo-products-grid");
    var wrap = this.ensureLoadMoreContainer(gridEl);
    if (!wrap) return;

    if (!totalCount || visibleCount >= totalCount) {
      wrap.innerHTML = "";
      wrap.style.display = "none";
      return;
    }

    wrap.style.display = "";
    wrap.innerHTML =
      '<div class="poc-demo-load-more__inner">' +
        '<div class="poc-demo-load-more__meta">Showing ' + POC.ui.escapeHtml(String(Math.min(visibleCount, totalCount))) + ' of ' + POC.ui.escapeHtml(String(totalCount)) + ' products</div>' +
        '<button type="button" id="poc-demo-load-more" class="poc-demo-load-more__button">Load More</button>' +
      '</div>';
  },

  bindFullCardClickThrough() {
    Array.prototype.forEach.call(document.querySelectorAll(".poc-demo-card[data-product-url]"), function (card) {
      if (card.dataset.fullCardClickBound === "true") return;
      card.dataset.fullCardClickBound = "true";

      card.setAttribute("role", "link");
      if (!card.hasAttribute("tabindex")) {
        card.setAttribute("tabindex", "0");
      }

      card.addEventListener("click", function (event) {
        var interactive = event.target && event.target.closest && event.target.closest(
          "a, button, input, select, textarea, label, [data-compare-toggle], [data-card-swatch], [data-swatch-more], [data-no-card-click]"
        );

        if (interactive) return;

        var url = card.getAttribute("data-current-product-url") || card.getAttribute("data-product-url") || "";
        if (url) {
          window.location.href = url;
        }
      });

      card.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;

        var active = document.activeElement;
        var interactive = active && active.closest && active.closest(
          "a, button, input, select, textarea, label, [data-compare-toggle], [data-card-swatch], [data-swatch-more], [data-no-card-click]"
        );

        if (interactive && interactive !== card) return;

        var url = card.getAttribute("data-current-product-url") || card.getAttribute("data-product-url") || "";
        if (url) {
          event.preventDefault();
          window.location.href = url;
        }
      });
    });
  },

  getUrlFilterValueForEmptyState(filters) {
    filters = filters || {};

    var direct = String(
      filters.tag ||
      filters.urlTag ||
      filters.categoryTag ||
      filters.packageTag ||
      ""
    ).trim();

    if (direct) return direct;

    try {
      var params = new URLSearchParams(window.location.search || "");

      /*
        Category is intentionally excluded here because it is already represented
        by POC.state.selectedCategoryName. Treating ?category=... as an independent
        Store Search Tag caused customer-facing admin/debug language to appear for
        normal category + label combinations.
      */
      var keys = [
        "tag",
        "productTag",
        "storeTag",
        "searchTag",
        "package",
        "packageTag",
        "collection"
      ];

      for (var i = 0; i < keys.length; i += 1) {
        var value = String(params.get(keys[i]) || "").trim();
        if (value) return value;
      }
    } catch (error) {}

    return "";
  },

  getUrlFilterDisplayLabel(value) {
    var text = String(value || "").trim();
    if (!text) return "this filter";

    try {
      text = decodeURIComponent(text);
    } catch (error) {}

    var normalized = text
      .replace(/^tag[:=]/i, "")
      .replace(/^category[:=]/i, "")
      .replace(/^package[:=]/i, "")
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (/^package spiritwear$/i.test(normalized)) {
      return "Spirit Wear Packages";
    }

    return normalized || "this filter";
  },

  getCuratedFilterDisplayLabel(value) {
    var normalized = String(value || "ALL")
      .trim()
      .toUpperCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");

    if (!normalized || normalized === "ALL") return "";
    if (
      normalized === "PACKAGE" ||
      normalized === "PACKAGES" ||
      normalized === "PACKAGE DEAL" ||
      normalized === "PACKAGE DEALS"
    ) {
      return "Package Deals";
    }
    if (normalized === "FEATURED") return "Featured Products";
    if (normalized === "TOP PICK") return "Top Picks";
    if (normalized === "RECOMMENDED") return "Recommended Products";
    if (normalized === "ON SALE") return "On Sale";

    return normalized
      .toLowerCase()
      .replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });
  },

  getBrandDisplayLabel(value) {
    var brand = String(value || "").trim();
    if (!brand) return "";

    return /apparel$/i.test(brand)
      ? brand
      : brand + " Apparel";
  },

  getActiveFilterContext(filters) {
    filters = filters || {};

    var state = POC.state || {};
    var categoryId = String(state.selectedCategoryId || "ALL");
    var sourceCategoryName = String(
      state.selectedCategoryName || ""
    ).trim();

    var categoryName =
      categoryId !== "ALL" && sourceCategoryName
        ? this.getCategoryDisplayName(sourceCategoryName)
        : "";

    var packageValue = this.getUrlFilterValueForEmptyState(filters);
    var packageName = packageValue
      ? this.getUrlFilterDisplayLabel(packageValue)
      : "";

    if (!/package/i.test(packageName)) {
      packageName = "";
    }

    return {
      search: String(filters.search || "").trim(),
      packageName: packageName,
      category: categoryName,
      label: this.getCuratedFilterDisplayLabel(
        filters.curatedFilter || "ALL"
      ),
      curatedOnly: filters.curatedOnly === true,
      brand: this.getBrandDisplayLabel(filters.brand || ""),
      color: String(filters.color || "").trim(),
      size: String(filters.size || "").trim()
    };
  },

  getActiveFilterDescriptions(filters) {
    var context = this.getActiveFilterContext(filters);
    var descriptions = [];

    if (context.search) {
      descriptions.push('Search: “' + context.search + '”');
    }
    if (context.packageName) {
      descriptions.push("Package: " + context.packageName);
    }
    if (context.category) {
      descriptions.push("Category: " + context.category);
    }
    if (context.label) {
      descriptions.push("Label: " + context.label);
    }
    if (context.curatedOnly) {
      descriptions.push("Curated only");
    }
    if (context.brand) {
      descriptions.push("Brand: " + context.brand);
    }
    if (context.color) {
      descriptions.push("Color: " + context.color);
    }
    if (context.size) {
      descriptions.push("Size: " + context.size);
    }

    return descriptions;
  },

  buildNoProductsMessage(filters, activeUrlFilter) {
    filters = filters || {};

    var context = this.getActiveFilterContext(filters);
    var descriptions = this.getActiveFilterDescriptions(filters);
    var hasToolbarFilter = !!(
      context.search ||
      context.packageName ||
      context.label ||
      context.curatedOnly ||
      context.brand ||
      context.color ||
      context.size
    );

    /*
      Prefer the actual customer-selected category/filter combination.
      This prevents ?category=... from being described as an internal
      InkSoft Store Search Tag.
    */
    if (hasToolbarFilter || context.category) {
      var bodyParts = [];

      if (context.packageName) {
        bodyParts.push("Package: " + context.packageName);
      }
      if (context.category) {
        bodyParts.push("Category: " + context.category);
      }
      if (context.label) {
        bodyParts.push("Label: " + context.label);
      }
      if (context.brand) {
        bodyParts.push("Brand: " + context.brand);
      }
      if (context.color) {
        bodyParts.push("Color: " + context.color);
      }
      if (context.size) {
        bodyParts.push("Size: " + context.size);
      }
      if (context.curatedOnly) {
        bodyParts.push("Curated products only");
      }
      if (context.search) {
        bodyParts.unshift('Search: “' + context.search + '”');
      }

      var naturalBody = "";

      if (context.search) {
        naturalBody =
          'No products matched “' + context.search +
          '” with the current filter combination.';
      } else if (context.packageName) {
        naturalBody =
          "No products are currently available in " +
          context.packageName +
          ".";
      } else if (context.category && context.label) {
        naturalBody =
          "There are currently no products in " +
          context.category +
          " matching " +
          context.label +
          ".";
      } else if (context.category && context.brand) {
        naturalBody =
          "There are currently no " +
          context.brand +
          " products in " +
          context.category +
          ".";
      } else if (context.brand && context.label) {
        naturalBody =
          "There are currently no " +
          context.brand +
          " products matching " +
          context.label +
          ".";
      } else if (context.category) {
        naturalBody =
          "There are currently no products matching the selected filters in " +
          context.category +
          ".";
      } else {
        naturalBody =
          "There are currently no products matching this filter combination.";
      }

      return {
        className: "poc-demo-empty--filters",
        title: "No matching products found",
        body: naturalBody,
        helper:
          descriptions.length > 1
            ? "Active filters: " + descriptions.join(" • ")
            : (
                descriptions.length
                  ? descriptions[0]
                  : "Try removing one or more filters."
              )
      };
    }

    if (activeUrlFilter) {
      var urlLabel = this.getUrlFilterDisplayLabel(activeUrlFilter);

      return {
        className: "poc-demo-empty--url-filter",
        title: 'No products found for “' + urlLabel + '”',
        body:
          "There are currently no active products matching this selection.",
        helper:
          "Try browsing all products or clearing the current selection."
      };
    }

    return {
      className: "poc-demo-empty--filters",
      title: "No products found",
      body: "No products are currently available for this selection.",
      helper: "Try browsing all products or refreshing the page."
    };
  },

  getProductsContentHeading() {
    var filters = POC.state && POC.state.filters
      ? POC.state.filters
      : {};

    var context = this.getActiveFilterContext(filters);
    var parts = [];

    if (context.search) {
      parts.push('Search Results for “' + context.search + '”');
    } else if (context.packageName) {
      parts.push(context.packageName);
    } else if (context.category) {
      parts.push(context.category);
    }

    if (context.brand) {
      parts.push(context.brand);
    }

    if (context.label) {
      parts.push(context.label);
    }

    if (context.color) {
      parts.push(context.color);
    }

    if (context.size) {
      parts.push("Size " + context.size);
    }

    if (context.curatedOnly) {
      parts.push("Curated");
    }

    if (!parts.length) {
      return "All Products";
    }

    return parts.join(" — ");
  },

  renderProducts(payload) {
    var gridEl = document.getElementById("poc-demo-products-grid");
    var countEl = document.getElementById("poc-demo-products-count");
    var summaryEl = document.getElementById("poc-demo-products-summary");
    var toolbarEl = document.getElementById("poc-demo-products-toolbar");
    var headingEl = document.getElementById("poc-demo-products-heading");

    if (!gridEl || !countEl || !summaryEl || !toolbarEl || !headingEl) return;

    var all = this.getPayloadProducts(payload);
    var sorted = this.sortProducts(all);
    var filtered = this.filterProducts(sorted);

    // A default toolbar must never hide a valid server response.
    if (!filtered.length && sorted.length && !this.hasActiveProductFilters()) {
      filtered = sorted.slice();
    }

    if (!all.length && payload && Number(payload.total || payload.count || 0) > 0) {
      console.warn("[POC.render] Product payload reported a positive count but no product array was found:", payload);
    }

    this.renderFilterOptions(sorted, filtered);

    var visibleCount = POC.core && POC.core.getVisibleCount ? POC.core.getVisibleCount() : 48;
    var visibleProducts = filtered.slice(0, visibleCount);

    countEl.textContent = filtered.length + " item(s)";
    headingEl.textContent = this.getProductsContentHeading();
    toolbarEl.style.display = "";

    var filters = POC.state.filters || {};
    var filterDescriptions = this.getActiveFilterDescriptions(filters);

    var activeContext = this.getActiveFilterContext(filters);

    this.syncPresetChipActiveState(activeContext);

    if (activeContext.packageName) {
      var packageDetails = filterDescriptions.filter(function (description) {
        return description.indexOf("Package: ") !== 0;
      });

      summaryEl.textContent = packageDetails.length
        ? "Showing products in " + activeContext.packageName + " matching: " + packageDetails.join(" • ")
        : "Showing products included in " + activeContext.packageName + ".";
    } else if (filterDescriptions.length) {
      summaryEl.textContent =
        "Showing products matching: " +
        filterDescriptions.join(" • ");
    } else if (String(POC.state.selectedCategoryId || "ALL") === "ALL") {
      summaryEl.textContent =
        "Showing all products, with curated selections first.";
    } else {
      summaryEl.textContent =
        "Showing products in " +
        this.getCategoryDisplayName(POC.state.selectedCategoryName || "this category") +
        ", with curated selections first.";
    }

    if (!filtered.length) {
      var activeUrlFilter = this.getUrlFilterValueForEmptyState(filters);
      var message = this.buildNoProductsMessage(filters, activeUrlFilter);
      var browseAllUrl = window.location.pathname || "/pages/product";
      var canBindClear = POC.core && typeof POC.core.bindEmptyStateClearFilters === "function";

      var clearButtonHtml = canBindClear
        ? '<button class="poc-demo-button poc-demo-button--secondary" type="button" data-clear-filters>Clear Filters</button>'
        : "";

      gridEl.innerHTML =
        '<div class="poc-demo-empty ' + POC.ui.escapeHtml(message.className) + '" style="grid-column:1/-1;">' +
          '<h3>' + POC.ui.escapeHtml(message.title) + '</h3>' +
          '<p>' + POC.ui.escapeHtml(message.body) + '</p>' +
          (message.helper
            ? '<p class="poc-demo-empty__helper">' + POC.ui.escapeHtml(message.helper) + '</p>'
            : "") +
          '<div class="poc-demo-empty__actions">' +
            '<a class="poc-demo-button" href="' + POC.ui.escapeHtml(browseAllUrl) + '">Browse All Products</a>' +
            clearButtonHtml +
          '</div>' +
        '</div>';

      this.renderLoadMore(0, 0);

      if (canBindClear) {
        POC.core.bindEmptyStateClearFilters();
      }

      if (POC.core && POC.core.bindCompareEvents) {
        POC.core.bindCompareEvents();
      }
      return;
    }

    var renderCycleId = this.nextRenderCycleId();

    gridEl.innerHTML = visibleProducts.map(this.buildProductCard.bind(this)).join("");
    this.renderLoadMore(
        filtered.length,
        visibleProducts.length
      );

    Array.prototype.forEach.call(
      gridEl.querySelectorAll("[data-preview-id]"),
      function (button) {
        button.addEventListener("click", function () {
          var productId = button.getAttribute("data-preview-id") || "";
          if (productId) {
            POC.core.openProductPreview(productId);
          }
        });
      }
    );

    this.bindCardSwatchEvents(gridEl);

    if (POC.core && POC.core.bindCompareEvents) {
      POC.core.bindCompareEvents();
    }

    if (POC.core && POC.core.bindLoadMoreEvents) {
      POC.core.bindLoadMoreEvents();
    }

    this.scheduleVisibleCardSwatchHydration(visibleProducts, {
      scopeRoot: gridEl,
      renderCycleId: renderCycleId
    });
  },

  getCompareSelectedProducts() {
    var ids = POC.state && POC.state.compare && Array.isArray(POC.state.compare.selected)
      ? POC.state.compare.selected
      : [];

    return ids.map(function (id) {
      return (POC.core && POC.core.findProductInLoadedState ? POC.core.findProductInLoadedState(id) : null)
        || (POC.state && POC.state.productDetailCache ? POC.state.productDetailCache[String(id)] : null)
        || { id: id, name: "Product " + id };
    }).filter(Boolean);
  },

  renderCompareTray() {
    var trayEl = document.getElementById("poc-demo-compare-tray");
    var countEl = document.getElementById("poc-demo-compare-count");
    var listEl = document.getElementById("poc-demo-compare-items");
    var openBtn = document.getElementById("poc-demo-compare-open");
    var clearBtn = document.getElementById("poc-demo-compare-clear");

    if (!trayEl || !countEl || !listEl || !openBtn || !clearBtn) return;

    var selected = this.getCompareSelectedProducts();
    var max = POC.state && POC.state.compare && Number(POC.state.compare.max) > 0
      ? Number(POC.state.compare.max)
      : 3;

    countEl.textContent = selected.length + " / " + max + " selected";

    if (!selected.length) {
      trayEl.style.display = "none";
      listEl.innerHTML = "";
      openBtn.disabled = true;
      clearBtn.disabled = true;
      return;
    }

    trayEl.style.display = "";
    openBtn.disabled = selected.length < 2;
    clearBtn.disabled = false;

    listEl.innerHTML = selected.map(function (product) {
      var id = product && product.id != null ? String(product.id) : "";
      var name = product && product.name ? product.name : ("Product " + id);
      var thumb = product && product.thumbnailUrl ? product.thumbnailUrl : "";

      return '' +
        '<div class="poc-demo-compare-pill">' +
          (thumb
            ? '<img class="poc-demo-compare-pill__thumb" src="' + POC.ui.escapeHtml(thumb) + '" alt="' + POC.ui.escapeHtml(name) + '">'
            : '<div class="poc-demo-compare-pill__thumb poc-demo-compare-pill__thumb--empty"></div>') +
          '<div class="poc-demo-compare-pill__text">' +
            '<div class="poc-demo-compare-pill__name">' + POC.ui.escapeHtml(name) + '</div>' +
            '<div class="poc-demo-compare-pill__id">ID: ' + POC.ui.escapeHtml(id) + '</div>' +
          '</div>' +
          '<button type="button" class="poc-demo-compare-pill__remove" data-compare-remove="' + POC.ui.escapeHtml(id) + '" aria-label="Remove compare item">×</button>' +
        '</div>';
    }).join("");

    this.bindCardSwatchEvents(gridEl);

    if (POC.core && POC.core.bindCompareEvents) {
      POC.core.bindCompareEvents();
    }
  },

  buildCompareValue(value) {
    var text = String(value == null ? "" : value).trim();
    return text ? POC.ui.escapeHtml(text) : "—";
  },

  buildCompareHtmlValue(html, fallbackText) {
    var safeHtml = String(html || "").trim();
    if (safeHtml) {
      return '<div class="poc-demo-compare-table__html">' + safeHtml + '</div>';
    }

    var text = String(fallbackText || "").trim();
    return text ? POC.ui.escapeHtml(text) : "—";
  },

buildCompareColorSwatchesHtml(product) {
  var options = this.getProductColorOptions(product);

  if (!Array.isArray(options) || !options.length) {
    return "—";
  }

  var visible = options; // Compare modal shows ALL colors

  return '' +
    '<div class="poc-demo-compare-colors">' +
      '<div class="poc-demo-compare-colors__swatches">' +
        visible.map(function (item) {
          var bg = item.color1 || item.color2 || "#D9DEE7";
          var bgStyle = item.color1 && item.color2 && item.color1 !== item.color2
            ? 'linear-gradient(135deg, ' + item.color1 + ' 0%, ' + item.color1 + ' 48%, ' + item.color2 + ' 52%, ' + item.color2 + ' 100%)'
            : bg;

          return '' +
            '<span class="poc-demo-compare-colors__swatch" title="' + POC.ui.escapeHtml(item.name || "Color Option") + '">' +
              '<span class="poc-demo-compare-colors__swatch-inner" style="background:' + POC.ui.escapeHtml(bgStyle) + ';"></span>' +
            '</span>';
        }).join('') +
      '</div>' +
      '<div class="poc-demo-compare-colors__labels">' +
        visible.map(function (item) {
          return '<span class="poc-demo-compare-colors__label">' + POC.ui.escapeHtml(item.name || "Color Option") + '</span>';
        }).join('') +
      '</div>' +
      
    '</div>';
},



renderCompareModal(products) {
    var contentEl = document.getElementById("poc-demo-modal-content");
    if (!contentEl) return;

    var items = Array.isArray(products) ? products : [];
    if (!items.length) {
      contentEl.innerHTML = '<div class="poc-demo-modal__loading">No products selected for compare.</div>';
      return;
    }

    var self = this;
    var productColumnCount = items.length || 1;

    function getPrimaryThumb(product) {
      if (product && product.thumbnailUrl) return product.thumbnailUrl;
      var styles = self.buildModalStyleEntries(product);
      if (styles.length && styles[0].thumbnailUrl) return styles[0].thumbnailUrl;
      if (styles.length && styles[0].imageUrl) return styles[0].imageUrl;
      return product && product.primaryImage ? product.primaryImage : "";
    }

    function getSizeNames(product) {
      var sizes = self.getProductSizeLabels(product);
      return sizes.join(", ");
    }

    function getColorNames(product) {
      var colors = self.getProductColorNames(product);
      return colors.join(", ");
    }

    var rows = [
      {
        label: "Product",
        renderValue: function (product) {
          var id = product && product.id != null ? String(product.id) : "";
          var name = product && product.name ? product.name : ("Product " + id);
          var thumb = getPrimaryThumb(product);

          return '' +
            '<div class="poc-demo-compare-table__product-inline">' +
              (thumb
                ? '<img class="poc-demo-compare-table__thumb poc-demo-compare-table__thumb--inline" src="' + POC.ui.escapeHtml(thumb) + '" alt="' + POC.ui.escapeHtml(name) + '">'
                : '<div class="poc-demo-compare-table__thumb poc-demo-compare-table__thumb--inline poc-demo-compare-table__thumb--empty"></div>') +
              '<div class="poc-demo-compare-table__product-inline-body">' +
                '<div class="poc-demo-compare-table__name">' + POC.ui.escapeHtml(name) + '</div>' +
                '<div class="poc-demo-compare-table__id">ID: ' + POC.ui.escapeHtml(id) + '</div>' +
                '<div class="poc-demo-compare-table__actions">' +
                  '<a class="poc-demo-action-button poc-demo-action-button--quote poc-demo-request-quote" data-unisource-quote data-quote-modal href="' + POC.ui.escapeHtml(self.buildRequestQuoteUrl(product)) + '">Request a Quote</a>' +
                  '<a class="poc-demo-action-button poc-demo-action-button--view" href="/pages/inksoft-product?id=' + encodeURIComponent(id) + '">View Product</a>' +
                '</div>' +
              '</div>' +
            '</div>';
        }
      },
      {
        label: "SKU",
        renderValue: function (product) {
          return self.buildCompareValue(product && product.sku ? product.sku : "");
        }
      },
      {
        label: "Manufacturer SKU",
        renderValue: function (product) {
          return self.buildCompareValue(self.getProductManufacturerSkuValue(product));
        }
      },
      {
        label: "Brand",
        renderValue: function (product) {
          return self.buildCompareValue(self.getProductBrandValue(product));
        }
      },
      {
        label: "Description",
        renderValue: function (product) {
          return self.buildCompareHtmlValue(
            self.getProductDescriptionHtml(product),
            self.getProductDescriptionText(product)
          );
        }
      },
      {
        label: "Colors",
        renderValue: function (product) {
          return self.buildCompareColorSwatchesHtml(product);
        }
      },
      {
        label: "Sizes",
        renderValue: function (product) {
          return self.buildCompareValue(getSizeNames(product));
        }
      }
    ];

    contentEl.innerHTML =
      '<div class="poc-demo-compare-modal">' +
        '<div class="poc-demo-compare-modal__head">' +
          '<h2 class="poc-demo-modal__title">Compare Products</h2>' +
          '<div class="poc-demo-modal__line">Review up to 3 products side by side.</div>' +
        '</div>' +
        '<div class="poc-demo-compare-table-wrap">' +
          '<table class="poc-demo-compare-table">' +
            '<colgroup>' +
              '<col style="width:180px;">' +
              new Array(productColumnCount + 1).join('<col>') +
            '</colgroup>' +
            '<thead>' +
              '<tr>' +
                '<th>Field</th>' +
                items.map(function (product) {
                  var name = product && product.name ? product.name : "Product";
                  return '<th class="poc-demo-compare-table__column-head">' + POC.ui.escapeHtml(name) + '</th>';
                }).join('') +
              '</tr>' +
            '</thead>' +
            '<tbody>' +
              rows.map(function (row) {
                return '' +
                  '<tr>' +
                    '<td class="poc-demo-compare-table__label">' + POC.ui.escapeHtml(row.label) + '</td>' +
                    items.map(function (product) {
                      return '<td>' + row.renderValue(product) + '</td>';
                    }).join('') +
                  '</tr>';
              }).join('') +
            '</tbody>' +
          '</table>' +
        '</div>' +
      '</div>';
  },

  renderPreviewLoading() {
    var contentEl = document.getElementById("poc-demo-modal-content");
    if (!contentEl) return;
    contentEl.innerHTML = '<div class="poc-demo-modal__loading">Loading product detail…</div>';
  },

  buildModalStyleEntries(product) {
    var styles = Array.isArray(product && product.styles) ? product.styles : [];
    var productViews = Array.isArray(product && product.views) ? product.views : [];

    return styles.map(function (style, index) {
      var styleId = style && style.id != null ? String(style.id) : "style-" + index;
      var styleName = style && style.name ? style.name : "Style " + (index + 1);
      var styleViews = Array.isArray(style && style.views) ? style.views.slice() : [];

      var matchingViews = productViews.filter(function (view) {
        var viewStyleId = view && view.styleId != null ? String(view.styleId) : "";
        var viewStyleName = view && view.styleName ? String(view.styleName).toLowerCase() : "";
        var targetStyleName = styleName.toLowerCase();

        if (viewStyleId && viewStyleId === styleId) return true;
        if (viewStyleName && viewStyleName === targetStyleName) return true;

        var label = view && view.label ? String(view.label).toLowerCase() : "";
        return label.indexOf(targetStyleName) === 0;
      });

      if (!styleViews.length && matchingViews.length) {
        styleViews = matchingViews.slice();
      }

      var styleThumb = style && style.thumbnailUrl ? style.thumbnailUrl : "";
      var styleImage = style && style.imageUrl ? style.imageUrl : "";

      if (!styleThumb && styleViews.length && styleViews[0].thumbnailUrl) {
        styleThumb = styleViews[0].thumbnailUrl;
      }
      if (!styleImage && styleViews.length && styleViews[0].imageUrl) {
        styleImage = styleViews[0].imageUrl;
      }

      if (!styleImage) {
        styleImage = styleThumb || (product && product.primaryImage) || (product && product.thumbnailUrl) || "";
      }

      return {
        id: styleId,
        name: styleName,
        thumbnailUrl: styleThumb || styleImage,
        imageUrl: styleImage,
        htmlColor1: style && style.htmlColor1 ? style.htmlColor1 : "",
        htmlColor2: style && style.htmlColor2 ? style.htmlColor2 : "",
        isDefault: !!(style && style.isDefaultStyle),
        sizes: Array.isArray(style && style.sizes) ? style.sizes : [],
        views: styleViews
      };
    });
  },

  getSelectedStyle(product) {
    var styles = this.buildModalStyleEntries(product);
    var selectedStyleId = (POC.state.modalPreview && POC.state.modalPreview.selectedStyleId) || "";

    var selected =
      styles.find(function (style) { return style.id === selectedStyleId; }) ||
      styles.find(function (style) { return style.isDefault; }) ||
      styles[0] ||
      null;

    return {
      styles: styles,
      selected: selected
    };
  },

  getSelectedStyleSizes(selectedStyle, product) {
    if (selectedStyle && Array.isArray(selectedStyle.sizes) && selectedStyle.sizes.length) {
      return selectedStyle.sizes;
    }
    return Array.isArray(product && product.sizes) ? product.sizes : [];
  },

  getSelectedStyleViews(selectedStyle, product) {
    if (selectedStyle && Array.isArray(selectedStyle.views) && selectedStyle.views.length) {
      return selectedStyle.views;
    }

    if (Array.isArray(product && product.views) && product.views.length) {
      return product.views;
    }

    return [];
  },

  getInitialSelectedView(selectedStyle, product) {
    var selectedViewIndex = (POC.state.modalPreview && typeof POC.state.modalPreview.selectedViewIndex === "number")
      ? POC.state.modalPreview.selectedViewIndex
      : 0;

    var views = this.getSelectedStyleViews(selectedStyle, product);

    if (!views.length) {
      return {
        views: [],
        selectedView: null,
        selectedViewIndex: 0
      };
    }

    var safeIndex = selectedViewIndex >= 0 && selectedViewIndex < views.length ? selectedViewIndex : 0;

    return {
      views: views,
      selectedView: views[safeIndex],
      selectedViewIndex: safeIndex
    };
  },

  buildMainPreviewImage(selectedStyle, selectedView, product) {
    if (selectedView && selectedView.imageUrl) return selectedView.imageUrl;
    if (selectedStyle && selectedStyle.imageUrl) return selectedStyle.imageUrl;
    return (product && product.primaryImage) || (product && product.thumbnailUrl) || "";
  },

renderViewThumbnails(viewState) {
    var views = viewState.views || [];
    var selectedIndex = typeof viewState.selectedViewIndex === "number" ? viewState.selectedViewIndex : 0;

    if (!views.length) return "";

    return '' +
      '<div class="poc-demo-modal__view-strip">' +
        views.map(function (view, index) {
          var thumb = view && (view.thumbnailUrl || view.imageUrl) ? (view.thumbnailUrl || view.imageUrl) : "";
          var label = view && view.label ? view.label : ("View " + (index + 1));

          return '' +
            '<button type="button" class="poc-demo-modal__view-thumb' + (index === selectedIndex ? ' is-active' : '') + '" data-view-index="' + index + '" title="' + POC.ui.escapeHtml(label) + '">' +
              '<span class="poc-demo-modal__view-thumb-media">' +
                (thumb
                  ? '<img src="' + POC.ui.escapeHtml(thumb) + '" alt="' + POC.ui.escapeHtml(label) + '">'
                  : '<span class="poc-demo-modal__view-thumb-label">' + POC.ui.escapeHtml(label) + '</span>') +
              '</span>' +
              '<span class="poc-demo-modal__view-thumb-text">' + POC.ui.escapeHtml(label) + '</span>' +
            '</button>';
        }).join("") +
      '</div>';
  },

  renderModalProduct(product) {
    var contentEl = document.getElementById("poc-demo-modal-content");
    if (!contentEl) return;

    var modalData = this.getSelectedStyle(product);
    var styles = modalData.styles;
    var selectedStyle = modalData.selected;

    if (selectedStyle) {
      POC.state.modalPreview.selectedStyleId = selectedStyle.id;
    }

    var viewState = this.getInitialSelectedView(selectedStyle, product);
    if (typeof viewState.selectedViewIndex === "number") {
      POC.state.modalPreview.selectedViewIndex = viewState.selectedViewIndex;
    }

    var imageToShow = this.buildMainPreviewImage(selectedStyle, viewState.selectedView, product);
    var sizes = this.getSelectedStyleSizes(selectedStyle, product);
    var descriptionHtml = this.getProductDescriptionHtml(product);

    contentEl.innerHTML =
      '<div class="poc-demo-modal-grid">' +
        '<div>' +
          '<div class="poc-demo-modal__image-wrap">' +
            (imageToShow
              ? '<img class="poc-demo-modal__image" src="' + POC.ui.escapeHtml(imageToShow) + '" alt="' + POC.ui.escapeHtml(product.name || "") + '">'
              : '<div class="poc-demo-empty">No image available.</div>') +
          '</div>' +
          this.renderViewThumbnails(viewState) +
        '</div>' +
        '<div>' +
          '<h2 class="poc-demo-modal__title">' + POC.ui.escapeHtml(product.name || "Unnamed Product") + '</h2>' +
          '<div class="poc-demo-modal__primary-actions">' +
            '<a class="poc-demo-action-button poc-demo-action-button--quote poc-demo-request-quote" data-unisource-quote data-quote-modal href="' +
              POC.ui.escapeHtml(this.buildRequestQuoteUrl(product, {
                selectedStyle: selectedStyle,
                selectedStyleId: selectedStyle ? selectedStyle.id : "",
                selectedColor: selectedStyle ? selectedStyle.name : "",
                selectedView: viewState.selectedView,
                productImageUrl: imageToShow
              })) +
            '">Request a Quote</a>' +
            '<a class="poc-demo-modal__link" href="/pages/inksoft-product?id=' + encodeURIComponent(String(product.id || "")) + '">Open Full Product Page</a>' +
          '</div>' +
          (product.sku ? '<div class="poc-demo-modal__line">SKU: <strong>' + POC.ui.escapeHtml(product.sku) + '</strong></div>' : '') +
          (product.brand ? '<div class="poc-demo-modal__line">Brand: <strong>' + POC.ui.escapeHtml(product.brand) + '</strong></div>' : '') +
          '<div class="poc-demo-modal__panel">' +
            '<div class="poc-demo-modal__panel-title">Available Styles</div>' +
            '<div class="poc-demo-modal__swatches">' +
              (styles.length
                ? styles.map(function (style) {
                    var isActive = selectedStyle && style.id === selectedStyle.id;
                    return '' +
                      '<button type="button" class="poc-demo-modal__swatch' + (isActive ? ' is-active' : '') + '" data-style-id="' + POC.ui.escapeHtml(style.id) + '" title="' + POC.ui.escapeHtml(style.name) + '">' +
                        '<div class="poc-demo-modal__swatch-inner">' +
                          (style.thumbnailUrl
                            ? '<img src="' + POC.ui.escapeHtml(style.thumbnailUrl) + '" alt="' + POC.ui.escapeHtml(style.name || "") + '">'
                            : '<div class="poc-demo-modal__swatch-fallback"></div>') +
                        '</div>' +
                        '<span class="poc-demo-modal__swatch-text">' + POC.ui.escapeHtml(style.name || 'Style') + '</span>' +
                      '</button>';
                  }).join("")
                : '<div class="poc-demo-empty">No style data available.</div>') +
            '</div>' +
          '</div>' +
          '<div class="poc-demo-modal__panel">' +
            '<div class="poc-demo-modal__panel-title">Available Sizes</div>' +
            '<div class="poc-demo-modal__sizes">' +
              (sizes.length
                ? sizes.map(function (size) {
                    var label = size && (size.name || size.code || size.label) ? (size.name || size.code || size.label) : "";
                    return '<div class="poc-demo-modal__size">' + POC.ui.escapeHtml(label) + '</div>';
                  }).join("")
                : '<div class="poc-demo-empty">No size data available.</div>') +
            '</div>' +
          '</div>' +
          '<div class="poc-demo-modal__description-wrap">' +
            '<div class="poc-demo-modal__description-title">Description</div>' +
            '<div class="poc-demo-modal__description-html">' +
              (descriptionHtml || '<div class="poc-demo-empty">No description available.</div>') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    Array.prototype.forEach.call(
      contentEl.querySelectorAll("[data-style-id]"),
      function (button) {
        button.addEventListener("click", function () {
          var styleId = button.getAttribute("data-style-id") || "";
          POC.core.selectPreviewStyle(styleId);
        });
      }
    );

    Array.prototype.forEach.call(
      contentEl.querySelectorAll("[data-view-index]"),
      function (button) {
        button.addEventListener("click", function () {
          var viewIndex = Number(button.getAttribute("data-view-index") || "0");
          POC.core.selectPreviewView(viewIndex);
        });
      }
    );
  }
};

setTimeout(function(){ if (window.POC && POC.render && POC.render.bindFullCardClickThrough) POC.render.bindFullCardClickThrough(); }, 0);